import React, {PropsWithChildren} from 'react';
import {useEffectOnce} from 'react-use';

import {AppState} from '../../state-management/app';
import SubscriptionService from '../../services/subscription';

import {getMsgFromErr, parseQueryToField} from '../../utils';
import {PROMOTION_STATUS} from '../../constants/enum';

export type DataProvide = {
  [x in keyof Partial<AppState>]: AppState[x]
}

interface PaymentDataProviderProps extends AppState, PropsWithChildren<{}> {
  dataCallback: (data: DataProvide) => void
  onEndDataLoading: (err: string | null) => void
}


const PaymentDataProvider = (props: PaymentDataProviderProps) => {

  useEffectOnce(() => {
    async function fetchOnRefresh() {

      try {
        const {
          packageId: packageIdInUrl,
          planId: planIdInUrl,
        } = parseQueryToField(window.location.search, ['packageId', 'planId']);

        const data: DataProvide = { //set default value
          packages: props.packages,
          chosenPackage: props.chosenPackage
        };

        if (planIdInUrl && !props.planId) {
          data.packages = await SubscriptionService.retrievePackages(planIdInUrl!, props.token as string);
        }

        data.packages!.sort((a) => a.isRecommended ? -1 : 1);

        if (!props.chosenPackage) { // url has chosenPackageId but currently in state dont have (may be refresh the page)
          if (packageIdInUrl) {
            data.chosenPackage = data.packages!.find((pack) => pack.id === Number(packageIdInUrl));

          } else {
            data.chosenPackage = data.packages![0] || null;
          }
        }

        if (props.promotion.text) {
          data.promotion = {
            ...props.promotion,
            status: PROMOTION_STATUS.LOADING
          };
        }

        props.dataCallback(data);
      } catch (e) {
        props.onEndDataLoading(getMsgFromErr(e));
      } finally {
        props.onEndDataLoading(null);
      }
    }

    fetchOnRefresh();
  });

  return <>{!props.paymentLoading && props.children}</>;
};

export default PaymentDataProvider;
